var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"name":_vm.dataTableName,"items":_vm.contacts,"headers":_vm.headers,"loading":_vm.isLoading,"items-length":_vm.totalItems,"initial-options":_vm.initialTableOptions},on:{"optionsChanged":_vm.onOptionsChange}})}
var staticRenderFns = []

export { render, staticRenderFns }